import script from "./ChildMemu.vue?vue&type=script&setup=true&lang=js"
export * from "./ChildMemu.vue?vue&type=script&setup=true&lang=js"

import "./ChildMemu.vue?vue&type=style&index=0&id=bb183a80&scoped=true&lang=less"

import exportComponent from "../../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bb183a80"]])

export default __exports__